import React from 'react';

import { MainTablePage } from '../../components/MainTablePage';

import { EmailsSearchForm } from './EmailsSearchForm';
import { useDeleteEmailFilter } from './useDeleteEmailFilter';
import { useEmailsTableColumnDefinitions } from './useEmailsTableColumnDefinitions';
import { useEmailsTableDataSource } from './useEmailsTableDataSource';
import { useGetEmailsFilters } from './useGetEmailsFilters';
import { useSaveEmailFilter } from './useSaveEmailFilter';
import { useSearchEmails } from './useSearchEmails';
import { useUpdateEmailFilter } from './useUpdateEmailFilter';

export const EmailsPage: React.FC = () => (
  <MainTablePage
    getFilters={useGetEmailsFilters}
    saveFilter={useSaveEmailFilter}
    updateFilter={useUpdateEmailFilter}
    deleteFilter={useDeleteEmailFilter}
    getColumnsDefinition={useEmailsTableColumnDefinitions}
    search={useSearchEmails}
    getDataSource={useEmailsTableDataSource}
    storedFilterName="emailsFilter"
    storedPagingData="emailsPaging"
    title="Emails"
    searchForm={EmailsSearchForm}
  />
);
